import { render, staticRenderFns } from "./GeneralSettingsPanel.vue?vue&type=template&id=4f4050e0&scoped=true&lang=pug&"
import script from "./GeneralSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingsPanel.vue?vue&type=style&index=0&id=4f4050e0&lang=stylus&scoped=true&"
import style1 from "./GeneralSettingsPanel.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4050e0",
  null
  
)

export default component.exports